import type { Model } from '@patsnap/tahiti-core';
import type { EmbodimentState } from '../types';

export const EmbodimentModel = Symbol.for('EmbodimentModel');

export interface EmbodimentModel extends Model<EmbodimentState> {}
